import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextFieldProps,
} from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';

interface SelectFieldProps<FormValue extends FieldValues> {
  name: Path<FormValue>;
  control: Control<FormValue>;
  label: string;
  options: { id: string; name: string }[];
  defaultValue?: any;
  helperText?: TextFieldProps['helperText'];
}

export function SelectField<FormValue extends FieldValues>({
  name,
  control,
  label,
  options,
  defaultValue = '',
  helperText,
}: SelectFieldProps<FormValue>) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <InputLabel
            id={field.name}
            sx={theme => ({
              color: `${colorPalette.grey.dark} !important`,
              marginBottom: theme.spacing(0.4),
              transform: 'none',
              position: 'relative',
              userSelect: 'inherit',
            })}
          >
            {label}
          </InputLabel>
          <Select id={field.name} {...field} inputRef={ref} fullWidth>
            {options.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
          {(error || helperText) && (
            <FormHelperText error>{error?.message || helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
